import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileNavigation } from "./MobileNavigation";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <>
      {/* Margin and navigation clearance for every mobile screen, mirroring
          what Layout.tsx gives the desktop. Screens rendering straight into the
          shell -- projects, tickets, tasks, users -- had neither, so their
          tables ran edge to edge and their last row sat under the navigation
          bar. Doing it here means a screen does not have to know either exists. */}
      <div className="px-4 pb-20 max-w-screen-xl mx-auto">
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </div>
      <MobileNavigation />
      <Notification mobileOffset={{ bottom: "72px" }} />
    </>
  );
};
